// removed by extract-text-webpack-plugin
module.exports = {"messages":"CarrierMessages-module__messages___2CVdy","bottom":"CarrierMessages-module__bottom___3_1KO","shadow":"CarrierMessages-module__shadow___2TYdq","mobile":"CarrierMessages-module__mobile___2g5Ur"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/CarrierMessages/CarrierMessages.module.scss
// module id = 313
// module chunks = 0 1